export default __webpack_public_path__ + "static/media/barista1.58457979.png";